import { Card, CardMedia, Stack } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import React from "react";
import { baseUrlnoPort } from "../api/AdminApi";

export default function ReservationDetailsTable({ currentReservation }) {
  return (
    <Stack spacing={5}>
      <div>
        <Typography variant="h6">
          Customer Details for reservation {currentReservation.referenceNumber}
        </Typography>

        <TableContainer>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow id="header">
                <TableCell>First Name</TableCell>
                <TableCell>LastName</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>Country</TableCell>
                <TableCell>Flight Number</TableCell>
                <TableCell>Comments</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow key={currentReservation.id}>
                <TableCell>{currentReservation?.customerName}</TableCell>
                <TableCell>{currentReservation?.customerLastName}</TableCell>
                <TableCell>{currentReservation?.customerMail}</TableCell>
                <TableCell>{currentReservation?.customerPhone}</TableCell>
                <TableCell>{currentReservation?.customerAddress}</TableCell>
                <TableCell>{currentReservation?.customerCountry}</TableCell>
                <TableCell>{currentReservation?.flightNumber}</TableCell>
                <TableCell>{currentReservation?.comments}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <div>
        <Typography variant="h6">
          Extras {currentReservation.referenceNumber}
        </Typography>

        <TableContainer>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow id="header">
                <TableCell>Id</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Price/day</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Image</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currentReservation?.extras?.map((extra) => (
                <TableRow key={extra.id}>
                  <TableCell>{extra.id}</TableCell>
                  <TableCell>{extra.title}</TableCell>
                  <TableCell>{extra.pricePerDay}</TableCell>
                  <TableCell>{extra.quantity}</TableCell>
                  <TableCell>
                    <Card sx={{ maxWidth: 100, maxHeight: 100 }}>
                      <CardMedia
                        component="img"
                        image={baseUrlnoPort + extra["imageUrl"]}
                      />
                    </Card>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <div>
        <Typography variant="h6">
          Vehicle Details for reservation {currentReservation.referenceNumber}
        </Typography>

        <TableContainer>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow id="header">
                <TableCell>Name</TableCell>
                <TableCell>Price Per Day</TableCell>
                <TableCell>Insurance</TableCell>
                <TableCell>Image</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow key={currentReservation.name}>
                <TableCell>{currentReservation.vehicle.vehicleName}</TableCell>
                <TableCell>{currentReservation.vehicle.pricePerDay}</TableCell>
                <TableCell>{currentReservation.vehicle.pricePerDay}</TableCell>
                <TableCell>
                  <Card sx={{ maxWidth: 100, maxHeight: 100 }}>
                    <CardMedia
                      component="img"
                      image={
                        baseUrlnoPort + currentReservation.vehicle["vehicleUrl"]
                      }
                    />
                  </Card>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Stack>
  );
}
